import application from 'application/application';

const controller = 'CancelEmails';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$interval',
	'helper',
	'API',
	'$location',
	($scope, $rootScope, $http, $interval, helper, API, $location) => {
		$scope.unmarkedEmail = false;
		$scope.failedRequest = false;
		$scope.confirmingUnmarkEmail = false;
		$scope.disableTryAgain = false;
		$scope.confirmationCode = { value: '' };
		$scope.confirmRequest = false;
		$scope.canRequestAgain = true;
		$scope.canRequestWithCode = true;
		$scope.confirmationCodeIcon = '';

		$scope.countdownTime = 0;
		$scope.countdownSeconds = '00';
		let countdownInterval = null;

		let locationParams = $location.search();

		$scope.confirmUnmarkEmail = (
			failButton = false,
			startCountdown = false
		) => {
			$scope.confirmingUnmarkEmail = true;

			if ($scope.failedRequest) {
				$scope.disableTryAgain = true;

				setTimeout(() => {
					$scope.disableTryAgain = false;
					$scope.$apply();
				}, 2000);
			}

			if (locationParams.CodigoCancelamento) {
				if (locationParams.IdEvento) {
					locationParams.TodosEventos = false;
				} else {
					locationParams.TodosEventos = true;
				}

				if (locationParams.IdEvento) {
					locationParams.IdEvento = Number(locationParams.IdEvento);
				} else {
					locationParams.IdEvento = null;
				}

				if (locationParams.CodigoCancelamento.replace(' '))
					locationParams.CodigoCancelamento = locationParams.CodigoCancelamento.replace(
						/ /g,
						'+'
					);

				if (!$scope.canRequestAgain && !failButton) {
					return;
				}
				if (startCountdown) {
					$scope.canRequestAgain = false;
					$scope.startCountdown(30);
				}

				$http({
					...helper.http(API.cancelEmails, 'POST'),
					data: locationParams
				})
					.then(response => {
						if (
							response &&
							(response.status == 200 ||
								(response.status >= 200 && response.status < 300))
						) {
							$scope.unmarkedEmail = false;
							$scope.failedRequest = false;
							$scope.confirmRequest = true;
						} else {
							$scope.unmarkedEmail = false;
							$scope.failedRequest = true;
							$scope.confirmRequest = false;
						}
					})
					.catch(() => {
						$scope.unmarkedEmail = false;
						$scope.failedRequest = true;
						$scope.confirmRequest = false;
					})
					.finally(() => {
						$scope.confirmingUnmarkEmail = false;
					});
			}
		};

		$scope.confirmUnmarkEmailWithCode = code => {
			$scope.confirmingUnmarkEmail = true;

			if (!$scope.canRequestWithCode) {
				return;
			}
			$scope.canRequestWithCode = false;

			$http({
				...helper.http(API.cancelEmails, 'confirm'),
				method: 'GET',
				params: {
					codigoConfirmacao: code
				}
			})
				.then(response => {
					if (
						response &&
						(response.status == 200 ||
							(response.status >= 200 && response.status < 300))
					) {
						$scope.unmarkedEmail = true;
						$scope.failedRequest = false;
						$scope.confirmRequest = false;
					} else {
						$scope.unmarkedEmail = false;
						$scope.failedRequest = true;
						$scope.confirmRequest = false;
					}
				})
				.catch(() => {
					$scope.unmarkedEmail = false;
					$scope.failedRequest = true;
					$scope.confirmRequest = false;
				})
				.finally(() => {
					$scope.confirmingUnmarkEmail = false;
					$scope.canRequestWithCode = true;
					$scope.confirmationCode.value = '';
					if (
						$rootScope.$$phase !== '$apply' &&
						$rootScope.$$phase !== '$digest'
					) {
						$rootScope.$apply();
					}
				});
		};

		$scope.updateCode = event => {
			$scope.confirmationCodeIcon = 'loading';

			if ($scope.timeoutId) {
				clearTimeout($scope.timeoutId);
			}

			$scope.timeoutId = setTimeout(() => {
				const newCode = event;

				if (newCode.length == 6) {
					$scope.confirmationCodeIcon = 'success';
				} else {
					$scope.confirmationCodeIcon = '';
				}

				if (
					$rootScope.$$phase !== '$apply' &&
					$rootScope.$$phase !== '$digest'
				) {
					$rootScope.$apply();
				}
			}, 800);
		};

		$scope.startCountdown = seconds => {
			$scope.countdownTime = seconds;

			$scope.updateTimerDisplay();

			countdownInterval = $interval(() => {
				$scope.countdownTime--;
				$scope.updateTimerDisplay();

				if ($scope.countdownTime <= 0) {
					$interval.cancel(countdownInterval);
					$scope.canRequestAgain = true;
				}
			}, 1000);
		};

		$scope.updateTimerDisplay = () => {
			$scope.countdownSeconds = String($scope.countdownTime).padStart(2, '0');

			if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
				$rootScope.$apply();
			}
		};

		$scope.$on('$destroy', () => {
			if (countdownInterval) {
				$interval.cancel(countdownInterval);
			}
		});

		$scope.isMobile =
			window && window.innerWidth && window.innerWidth <= 991 ? true : false;

		$(window).resize(() => {
			let previousIsMobile = $scope.isMobile;

			$scope.isMobile = window.innerWidth <= 991;

			if ($scope.isMobile != previousIsMobile) {
				$scope.$apply();
			}
		});
	}
]);

export default controller;
